import PropTypes from 'prop-types';
// material
import { Box, Modal, Typography, Button } from '@mui/material';
// ------------------------------------------------------------------------------------------------

ConfirmationPopup.propTypes = {
    confirm: PropTypes.func,
    data: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.number
    ]),
    msg: PropTypes.string,
    title: PropTypes.string,
    sx: PropTypes.object,
};
// ------------------------------------------------------------------------------------------------

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    bgcolor: 'background.paper',
    p: 3,
    borderRadius: 1.5,
    width: 360,
    height: 200,
}

const buttonStyle = {
    backgroundColor: 'common.white',
    color: 'common.black',
    border: '1.5px solid',
    borderColor: 'grey.300',
    mx: 1,
    ':hover': {
        backgroundColor: 'common.white',
        boxShadow: 10,
    }
}
// ------------------------------------------------------------------------------------------------

export default function ConfirmationPopup({ confirm, data, msg, title, sx = {} }) {

    const onClickNo = () => {
        confirm(false);
    };

    const onClickYes = (event) => {
        confirm(true, data);
    };

    return (
        <div>
            <Modal open >
                <Box sx={{ ...style, ...sx }}>
                    <Typography variant='h6'>
                        {title}
                    </Typography>

                    <Typography variant='subtitle1' sx={{ mt: 3, textAlign: 'center', whiteSpace: "pre-line" }}>
                        {msg || 'Are you sure?'}
                    </Typography>

                    <Box sx={{ position: 'absolute', bottom: 16, right: 16 }} >
                        <Button variant="contained" onClick={onClickNo} sx={buttonStyle}> No  </Button>

                        <Button type="submit" variant="contained" onClick={onClickYes} > Yes </Button>
                    </Box>
                </Box>
            </Modal>
        </div >
    )
}